// Source: https://admin.hp.com/techpulse_assets/files/service_metadata/functional-service-meta.json
import serviceMeta from './service-meta.json';
import {Config} from './types';

const useServiceMeta = () => {
    return serviceMeta as Config;
};

export default useServiceMeta;
